// roomBookingActions.ts
import { roomBookingActionTypes } from "./roomBookingTypes";

// Action to handle API success
export const roomBookingApiResponseSuccess = (actionType: string, data: any) => ({
  type: roomBookingActionTypes.API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});

// Action to handle API error
export const roomBookingApiResponseError = (actionType: string, error: string) => ({
  type: roomBookingActionTypes.API_RESPONSE_ERROR,
  payload: { actionType, error },
});
  /**
   * @description Fetches the list of all room numbers from the backend and stores them in Redux state.
   * @impact roomOptions - Updates the list of available room numbers.
   * @impact isRoomListLoading - Sets to true during API call, false otherwise.
   * @impact errorMessage - Stores any error message encountered during the API call.
   */
  export const fetchRoomOptions = () => ({
    type: roomBookingActionTypes.FETCH_ROOM_OPTIONS,
  });
  /**
   * @description Fetches the booking details for a selected room number from the backend.
   * @param {string} selectedRoomNumber - The room number to fetch booking details for.
   * @impact activeBookingId - Updates the active booking ID for the selected room.
   * @impact balancePaymentDetails - Updates the payment details for the selected room.
   * @impact isBookingDetailsLoading - Sets to true during API call, false otherwise.
   * @impact errorMessage - Stores any error message encountered during the API call.
   */
  export const fetchBookingDetails = (selectedRoomNumber: string) => ({
    type: roomBookingActionTypes.FETCH_BOOKING_DETAILS,
    payload: selectedRoomNumber,
  });
  /**
   * @description Sets the selected room number in the Redux state.
   * @param {string} selectedRoomNumber - The room number selected by the user.
   * @impact selectedRoomNumber - Updates the selected room number.
   */
  export const setSelectedRoomNumber = (selectedRoomNumber: string) => ({
    type: roomBookingActionTypes.SET_SELECTED_ROOM_NUMBER,
    payload: selectedRoomNumber,
  });
  /**
   * @description Sets a user-visible error message in the Redux store.
   * @param {string} errorMessage - The error message to be displayed.
   * @impact errorMessage - Updates the error message in the state.
   */
  export const setErrorMessage = (errorMessage: string) => ({
    type: roomBookingActionTypes.SET_ERROR_MESSAGE,
    payload: errorMessage,
  });
  /**
   * @description Clears the error message from the Redux state.
   * @impact errorMessage - Resets the errorMessage to null.
   */
  export const clearErrorMessage = () => ({
    type: roomBookingActionTypes.CLEAR_ERROR_MESSAGE,
  });


  // /**
  //  * @description Clears the error message from the Redux state.
  //  * @impact errorMessage - Resets the errorMessage to null.
  //  */
  // export const approvedEntrySubmit = (data: any) => ({
  //   type: roomBookingActionTypes.APPROVED_ENTRY_SUBMIT,
  //   paylaod: data
  // });